<script setup lang="ts">
  import { computed } from 'vue'
  import ProjectTitle from './ProjectTitle.vue'

  const store = useProjectStore()
  const { drawer } = storeToRefs(store)
  const navigationItems = ref([
    { title: 'Overview', icon: 'mdi-home', event: '' },
    { title: 'GI Data', icon: 'mdi-map-marker-multiple', event: 'groundInvestigationDrawer' },
    { title: 'Classification', icon: 'mdi-palette', event: 'classificationDrawer' },
    { title: 'Raster Data', icon: 'mdi-layers-triple', event: 'rasterDataDrawer' },
    { title: 'Section Line', icon: 'mdi-chart-line-variant', event: 'profileDrawer' },
    { title: 'Lab Results', icon: 'mdi-information-outline', event: 'labResultsDrawer' },
    {
      title: 'Users',
      icon: 'mdi-account-multiple',
      event: 'userManagementDrawer'
    }
  ])

  const activeDrawer = computed(() => {
    const drawers = [
      'profileDrawer',
      'rasterDataDrawer',
      'groundInvestigationDrawer',
      'labResultsDrawer',
      'userManagementDrawer',
      'classificationDrawer'
    ]
    for (const drawer of drawers) {
      if (store[drawer].shown) {
        return drawer
      }
    }
    return ''
  })
</script>

<template>
  <v-navigation-drawer :width="drawer.shown ? drawer.width : 60">
    <v-list class="py-0">
      <ProjectTitle v-if="drawer.shown" />
      <v-divider v-if="drawer.shown" style="margin-top: 10px"></v-divider>
      <div class="d-flex flex-column">
        <v-list-item
          v-for="item in navigationItems"
          :key="item.title"
          @click="store.toggleDrawerType(item.event)"
          class="drawer-item"
          :class="{ 'active-drawer': activeDrawer === item.event }"
        >
          <template v-slot:prepend>
            <div class="d-flex flex-column justify-center align-start">
              <v-icon
                style="opacity: 1"
                :icon="item.icon"
                color="primary"
                :size="item.iconSize ? item.iconSize : 'large'"
              ></v-icon>
            </div>
          </template>

          <p
            :class="[item.title === 'Speckle' ? 'ml-2' : 'ml-3', 'text-body-1']"
            v-if="drawer.shown"
          >
            {{ item.title }}
          </p>
        </v-list-item>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<style scoped>
  .active-drawer {
    background-color: #e9f4f8;
  }

  .drawer-item:hover {
    background-color: #f4fcff;
  }

  .list-item-title-collapse {
    font-size: 12px;
    width: 50px;
    word-wrap: break-word;
  }
</style>
